import { Game } from '../../features/session/sessionModels';

function createGameStartingMessage(
    game: Game,
    pot: { patternId: number; value: number }[],
) {
    const patterns = game?.game.gamePatterns;
    let message = `Game starting. Match `;

    if (patterns !== undefined) {
        patterns.map(({ name }, index) => {
            const snippet = `${name} for up to ${pot[index].value} PP`;
            const prefix =
                patterns.length > 1 && index === patterns.length - 1
                    ? ' and '
                    : patterns.length > 1 && index > 0
                    ? ', '
                    : '';
            message = `${message}${prefix}${snippet}`;
        });
    }

    return `${message}!`;
}

export default createGameStartingMessage;
